// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"c5a64972","223":"958f4c8c","401":"5cb28f68"}[chunkId] + ".chunk.js";
};